module.exports = __webpack_public_path__ + "static/media/commsgroup-alt-logo 2.3a05ca7f.svg";